<template>
  <div id="chooseRole">
    <div class="chooseRole-title">请选择登录角色</div>
    <div>
      <div class="user-role-choose" v-for="(role, index) in userRoles" :key="index" @click="chooseRole(role.roleCode)">{{role.roleName}}</div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import Keychoose from '@/plugins/key-choose';
import { filter, concat } from 'lodash';
export default {
  name: 'chooseRole',
  data() {
    return {
      user: this.$store.state.user.userInfo
    };
  },
  mounted() {
    this.addKeyUp();
  },
  computed: {
    userRoles: function() {
      let otherRole = filter(this.user.userRoles, function(o) {
        return o.roleCode !== 2;
      });
      let buyerAdminRole = filter(this.user.userRoles, function(o) {
        return o.roleCode === 2;
      });
      let arr = concat(otherRole, buyerAdminRole);
      return arr;
    }
  },
  methods: {
    chooseRole: function(roleCode) {
      this.$store.dispatch('changeUserRole', roleCode).then(data => {
        if (data && data.error) {
          this.$message.error(data.message);
        }
      });
    },
    addKeyUp: function() {
      var keyChoose = new Keychoose({ class: '.user-role-choose' });
      $(document).bind('keydown', function(e) {
        if (e.keyCode === 38) {
          e.preventDefault();
          keyChoose.prev();
        }
        if (e.keyCode === 40) {
          e.preventDefault();
          keyChoose.next();
        }
        if (e.keyCode === 13) {
          e.preventDefault();
          $('.user-role-choose')
            .eq(keyChoose.getIndex())
            .click();
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
#chooseRole {
  .chooseRole-title {
    color: #707070;
    font-size: 1.8em;
    margin: 0;
    text-align: center;
    font-family: 'Adobe Heiti Std';
    padding-top: 30px;
    padding-bottom: 20px;
  }
  .user-role-choose {
    text-align: center;
    font-size: 1.2em;
    padding: 0.6em 0px;
    color: rgb(112, 112, 112);
    font-family: 'Microsoft YaHei';
    cursor: pointer;
  }
}
</style>
